import { render, staticRenderFns } from "./ZTablePagination.vue?vue&type=template&id=2b6d0e06&scoped=true&"
import script from "./ZTablePagination.vue?vue&type=script&lang=js&"
export * from "./ZTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./ZTablePagination.vue?vue&type=style&index=0&id=2b6d0e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d0e06",
  null
  
)

export default component.exports